@if (notificationsVisible) {
  <mnc-notification-notifications-bell
    *featureToggleContent="FeatureFlags.Notifications"
    lazyComponent
    (viewAllClicked)="handleViewAllNotifications()"
    (notificationClicked)="handleNotificationClick($event)"
  ></mnc-notification-notifications-bell>
}



